import { ContextProviderState } from './types';

export const initialState: ContextProviderState = {
  token: null,
  notification: null,
  suggestionNotifications: [],
  tab: 'Dashboard',
  user: null,
  userSuggestions: [],
  curator: null,
  curatorSuggestions: [],
  curators: [],
  playlists: [],
  currPlaylist: null,
  curatorPlaylist: null,
  isPlaylistSearching: true,
  playlistSearchQuery: null,
  playlistSearchResults: [],
  isSongSearching: false,
  songsSearchQuery: null,
  songsSearchResults: [],
  isCuratorSearching: true,
  curatorsSearchQuery: null,
  curatorsSearchResults: [],
  songStatus: false,
  currSong: null,
  recentSongs: null,
  isPlaying: false,
  songObj: null,
  spotify: null
};
